import React from 'react'

import {
  Button,
  ButtonSet,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Text,
} from '@indeed/ifl-components'
import { Form } from 'react-bootstrap'
import { LoginTroubleModalProps as Props } from './LoginResetPasswordModal.types'
import { Input } from '@indeed/ifl-components'

const LoginResetPasswordModal = ({ isOpen, handleOnExit, onTypeEmail, handleResetPassword }: Props) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => handleOnExit()} data-testid="login-password-modal">
      <DialogContent>
        <DialogHeader>Confirmation</DialogHeader>
        <DialogBody>
          <Text as="p" data-testid="fill-your-address" level={3}>
            Fill out your email address here and click "reset password".
          </Text>
          <Form data-testid="form-reset-password" className={`login`} onSubmit={handleResetPassword}>
            <Input aria-label="Email" type="text" onChange={onTypeEmail} id="email" />
          </Form>
        </DialogBody>
        <DialogFooter>
          <ButtonSet>
            <Button variant="secondary" onClick={handleOnExit}>
              Close
            </Button>
            <Button onClick={handleResetPassword}>Reset password</Button>
          </ButtonSet>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default LoginResetPasswordModal
